import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

export default function Phone({ children, invert }) {
    const query = invert ? 'min-width:601px' : 'max-width:600px';
    return <MediaQuery query={`(${query})`}>{children}</MediaQuery>;
}
Phone.propTypes = {
    invert: PropTypes.bool
};
Phone.defaultProps = {
    invert: false
};